function cleanCaptionList(selector) {
  if (document.querySelector(selector)) {
    document.querySelector(selector).innerHTML = "";
  }
}

function showCaption(party, selector) {
  const parent = document.querySelector(selector);
  const classIdentifier = party.partyCode;

  if (parent && !parent.querySelector(`li.party-${classIdentifier}`)) {
    let elm = `<li class="c-leyenda__item party-${classIdentifier} ${classIdentifier}"><span class="c-leyenda__seats">
      ${party.partyName}</span>%seatsHtml</li>`;
    const seatsHtml = party.seats
      ? `<span class="c-leyenda__seats--value"> ${party.seats}</span>`
      : "";

    elm = elm.replace("%seatsHtml", seatsHtml);

    parent.insertAdjacentHTML("beforeend", elm);
  }
}

module.exports = {
  showCaption,
  cleanCaptionList,
};
